'use client';

import * as React from 'react';
import ReactPlayer from 'react-player/lazy';

import { Play } from '@/components/ui/Icons';
import HeadlessModal from '@/components/shared/HeadlessModal';
import Image from 'next/image';
import { useTranslations } from 'next-intl';

interface VideoModalProps {
  videoSrc?: string;
  thumbnail?: string;
}

export default function HeroVideo({ videoSrc, thumbnail }: VideoModalProps) {
  const [isOpen, setIsOpen] = React.useState(false);
  const t = useTranslations();

  return (
    <>
      <div className="relative mb-[30px] w-[100%] rounded-[20px] lg:mb-0">
        {thumbnail && (
          <Image
            src={thumbnail}
            width={500}
            height={500}
            alt="Vendor promo video thumbnail"
            className="object-fill"
          />
        )}
        {/* <Image
          src={videoShot}
          fill
          sizes="100vw"
          placeholder="blur"
          alt="Vendor promo video thumbnail"
          // className="object-contain md:object-cover lg:object-contain xl:object-cover"
          className="object-fill"
        /> */}
        <div className="absolute inset-0 flex items-center justify-center">
          <button
            onClick={() => setIsOpen(true)}
            className=""
            aria-label={t('aria.play_video_to_know_more')}
          >
            <div className="relative flex h-[66.54px] w-[66.54px] items-center justify-center rounded-full bg-white bg-opacity-30 text-primary-700  hover:text-white lg:h-[130px] lg:w-[130px] lg:bg-transparent lg:bg-opacity-100 lg:bg-[url('/video-play-bg.png')]">
              <Play />
            </div>
          </button>
        </div>
      </div>
      <HeadlessModal
        isOpen={isOpen}
        closeModal={() => setIsOpen(false)}
        dialogPanelClassName="!min-h-min !w-11/12 md:!max-w-[725px] !p-0 !rounded-[10px] !bg-transparent"
        dialogCloseBtnClassName="!hidden"
      >
        <div className="">
          <ReactPlayer
            url={videoSrc || 'https://youtu.be/zRnRhOWyzzI'}
            playing={true}
            height="405px"
            width="720px"
          />
        </div>
      </HeadlessModal>
    </>
  );
}
